import {useContext} from 'react'
import {Col, Row} from 'react-bootstrap'
import Select, {SingleValue} from 'react-select'
import {EntityByProcessContext} from '../EntityByProcessContext'

const allOption = {
  label: 'Todos',
  value: 'all',
}

export const EntityByProcessHeader: React.FC = () => {
  const {dataFields, setFieldSelected} = useContext(EntityByProcessContext)

  const options = [
    allOption,
    ...(dataFields?.map((context) => {
      return {
        label: context.label,
        options: context.fields.map((field) => {
          return {
            label: field.label,
            value: field.identifier,
          }
        }),
      }
    }) ?? []),
  ]

  return (
    <Row className='my-4'>
      <Col md={3} lg={3}>
        <Select
          options={options}
          isSearchable
          placeholder='Selecciona un campo'
          onChange={(e: any) => {
            setFieldSelected(e?.value ?? 'all')
          }}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({...base, left: 110, top: 200, zIndex: 9999}),
          }}
        />
      </Col>
    </Row>
  )
}
